/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "CreateError",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "TakenAddress",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "TargetHasNoCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "mastercopy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "context",
                type: "bytes",
            },
        ],
        name: "MechCreated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "mastercopy",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "context",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "initialCall",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "deployMech",
        outputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MechFactory__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MechFactory__factory.bytecode = _bytecode;
MechFactory__factory.abi = _abi;
